// MGAV progress of a ShareJet booking, read defensively (bookings list and booking detail).
import type { AdminBookingMgavProgress } from '../api/types';

// mgavProgress shape isn't fixed by the contract — derive a percent defensively.
export function mgavPercent(p: AdminBookingMgavProgress | null | undefined): number | null {
  if (!p) return null;
  if (typeof p.percent === 'number') return Math.round(p.percent);
  if (typeof p.fraction === 'number') return Math.round(p.fraction * 100);
  const booked = typeof p.seatsBooked === 'number' ? p.seatsBooked : undefined;
  const required =
    typeof p.minSeatsRequired === 'number'
      ? p.minSeatsRequired
      : typeof p.seatsRequired === 'number'
        ? p.seatsRequired
        : undefined;
  if (booked != null && required != null && required > 0) {
    return Math.min(100, Math.round((booked / required) * 100));
  }
  return null;
}

export function mgavLabel(p: AdminBookingMgavProgress | null | undefined): string | null {
  if (!p) return null;
  const booked = typeof p.seatsBooked === 'number' ? p.seatsBooked : undefined;
  const required =
    typeof p.minSeatsRequired === 'number'
      ? p.minSeatsRequired
      : typeof p.seatsRequired === 'number'
        ? p.seatsRequired
        : undefined;
  if (booked != null && required != null) return `${booked}/${required} seats`;
  return null;
}
